import { ListItemText, Skeleton } from "@mui/material";

interface ListItemTextSkeletonProps {
  primaryWidth?: string | number;
  secondaryWidth?: string | number;
  hideSecondary?: boolean;
}

export function ListItemTextSkeleton(props: ListItemTextSkeletonProps) {
  const { primaryWidth = "40%", secondaryWidth = "80%", hideSecondary = false } = props;

  return (
    <ListItemText
      primary={<Skeleton variant="text" width={primaryWidth} />}
      secondary={hideSecondary ? undefined : <Skeleton variant="text" width={secondaryWidth} />}
    />
  );
}
